module.exports = __webpack_public_path__ + "img/a1f1ef4.png";